


























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
type ZoneKey = keyof RentCalculator['plafond'];

@Component
export default class RentCalculator extends Vue {
  calculator = false;
  result = 0;
  base = 0;
  surfaceUtile = 0;
  coef = 0;
  calcul = {
    geozone: 'A' as ZoneKey,
    surface: 0,
    surface_terrace: 0,
    isRdc: false
  };

  plafond = {
    Abis: 19.51,
    A: 14.49,
    B1: 11.68,
    B2: 10.15
  };

  get monthYear() {
    const months = [
      'janvier','février','mars','avril','mai','juin',
      'juillet','août','septembre','octobre','novembre','décembre'
    ];
    const now = new Date();
    return `${months[now.getMonth()]} ${now.getFullYear()}`;
  }

  get isComputed() {
    return this.result > 0;
  }

  @Watch('calcul', { deep: true })
  calculateRent() {
    const { surface, surface_terrace, geozone, isRdc } = this.calcul;

    const sHab = parseFloat(String(surface)) || 0;
    const sTerr = parseFloat(String(surface_terrace)) || 0;

    if (sHab <= 0 || !this.plafond[geozone]) {
      this.result = 0;
      this.base = 0;
      this.surfaceUtile = 0;
      this.coef = 0;
      return;
    }

    const base = this.plafond[geozone];
    const sTerrUtil = isRdc ? 0 : sTerr;
    const surfaceUtile = sHab + Math.min(sTerrUtil / 2, 9);
    const coef = Math.min(0.7 + (19 / sHab), 1.2);
    const loyer = base * coef * surfaceUtile;

    this.base = base;
    this.surfaceUtile = parseFloat(surfaceUtile.toFixed(2));
    this.coef = parseFloat(coef.toFixed(3));
    this.result = parseFloat(loyer.toFixed(2));
  }
}
